import { ChevronDownIcon, FilterIcon } from 'components/icons';

export const FilterResults = () => {
  return (
    <div className="flex justify-end px-4 py-2 bg-opacity-50 bg-segments-accent-green-3 rounded-xl">
      <div className="flex items-center space-x-2">
        <FilterIcon className="w-5 h-5 text-black" />
        <p className="font-bold">Filter results</p>
        <ChevronDownIcon className="w-5 h-5 text-gray-500" />
      </div>
    </div>
  );
};
